import React from "react";
import "./index.css";
import Menu from "./menu";
type Props = {};
function index({}: Props) {
  return (
    <div className="Home">
      <h1 style={{ color: "white" }}>
        <span className="visu">Visu</span>
        alize Algo
        <span className="algo">rithms</span>
      </h1>
      <Menu />
      <h5 style={{ color: "white" }}>
        Only <span style={{ color: "#70cc72" }}> Sudoku Solver </span> &{" "}
        <span style={{ color: "#fe4365" }}> NQueen </span> are active right now!
      </h5>
    </div>
  );
}

export default index;
